import { EventsRequest } from 'src/core/models/requests/events.request';
import axios from '../axios';

export default async function eventRequest(
  request: Omit<EventsRequest, 'product'>
): Promise<void> {
  const body = { ...request, product: 'taraftarplus', userAgent: 'WEB' };
  const response = await axios.post<void>(
    `https://6mpp1sq7k1.execute-api.eu-west-1.amazonaws.com/prod/event`,
    body
  );
  return response.data;
}
